import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { CATEGORY_HIERARCHY } from '../utils/constants/category';

export const useValidatePath = () => {
	const params = useParams();
	const [category, setCategory] = useState(null);
	const [isValidating, setIsValidating] = useState(true);
	const [isInvalidPath, setIsInvalidPath] = useState(false);

	useEffect(() => {
		const paramsLength = Object.keys(params).length;

		const processInvalidPath = () => {
			setIsValidating(false);
			setIsInvalidPath(true);
		};

		const validateCategoryParam = (actCategoryConst, actCategory, paramIndex) => {
			if (paramIndex >= paramsLength) return actCategory;

			const key = Object.keys(params)[paramIndex];
			const paramCategory = params[key];

			if (paramCategory !== undefined) {
				try {
					const newCategory = actCategoryConst.categories.find(c => c.pathParam === paramCategory);

					if (newCategory) {
						return validateCategoryParam(newCategory, newCategory, paramIndex + 1);
					} else {
						processInvalidPath();
					}
				} catch (error) {
					processInvalidPath();
				}
			}

			return actCategory;
		};

		setCategory(validateCategoryParam(CATEGORY_HIERARCHY, null, 0));
		setIsValidating(false);
	}, [params]);

	return {
		category,
		isValidating,
		isInvalidPath
	};
};
